import { useCallback, useMemo, useState } from 'preact/hooks';
import { ExtendedReviewsWidgetSettings } from 'types/settings';
import { Filters, RatingDetails, RatingDetailsKeyToValue } from 'types/widget';

import { useSettings } from 'components/SettingsProvider';

export function useFilters() {
  const { utils } = useSettings<ExtendedReviewsWidgetSettings>();
  const [ratingFromFilter, setRatingFormFilter] = useState(1);
  const [ratingToFilter, setRatingToFilter] = useState(5);

  const changeRatingFilter = useCallback(
    (from: keyof RatingDetails, to: keyof RatingDetails = from) => {
      if (from) {
        setRatingFormFilter(RatingDetailsKeyToValue[from]);
      }

      if (to) {
        setRatingToFilter(RatingDetailsKeyToValue[to]);
      }
    },
    [],
  );

  const filters: Filters = useMemo(
    () => ({
      has_images: null,
      product_ids: utils.product?.id ? [utils.product?.id] : [],
      rating_from: ratingFromFilter,
      rating_to: ratingToFilter,
      verified: null,
    }),
    [ratingFromFilter, ratingToFilter, utils.product?.id],
  );

  return {
    changeRatingFilter,
    filters,
  };
}
